const splitAt = (index, x) => [
  x.slice(0, index).join(""),
  x.slice(index).join("")
];

export const ParseUriParams = UriString => {
  UriString = UriString.replace("?", "");
  const params = UriString.split("&");

  const keyvalues = {};

  for (let i = 0; i < params.length; i++) {
    var p = params[i];
    if (!isEmptyOrSpaces(p)) {
      var psplit = p.split("");
      var eqIndex = psplit.indexOf("=");
      var arr = splitAt(eqIndex, psplit);
      const key = arr[0];
      const value = arr[1].replace("=", "");

      if (!isEmptyOrSpaces(value)) {
        keyvalues[key] = value.toString().replace(/%20/g, " ");
      }
    }
  }

  return keyvalues;
};

function isEmptyOrSpaces(str) {
  return str === undefined || str === null || str.match(/^ *$/) !== null;
}



// WEBPACK FOOTER //
// ./src/helpers/UriReader.js